import { FC } from "react";
import { Accordion, Paper } from "@mantine/core";

export interface FilterPanelProps {
  value: string[];
  onChange: (value: string[]) => void;
}
//eslint-disable-next-line
export const FilterPanel: FC<FilterPanelProps> = ({
  value,
  onChange,
  children,
}) => {
  return (
    <Paper
      shadow="md"
      sx={{
        width: "100%",
        position: "sticky",
        top: "10px",
        backgroundColor: "#F8F9FA",
      }}
      p="md"
      withBorder
    >
      <Accordion multiple value={value} onChange={onChange}>
        {children}
      </Accordion>
    </Paper>
  );
};
